import $ from 'jquery';

export default function () {

    // one page with the bar over the banner (js/init/initHeaderOverlay.js): the bar keeps its place and height while its
    // background goes over (the first full height of the bar), only then it shrinks; measured before it shrinks
    const overlayHeader = document.querySelector('#header.header-overlay header');
    const overlayOffset = overlayHeader ? overlayHeader.offsetHeight : 0;

    let getOffset = function() {
        const grid = {xs: 576, sm: 768, md: 992, lg: 1200, xl: 1400, xxl: 32768};
        const offsets = {xs: 0, sm: 0, md: 50, lg: 50, xl: 80, xxl: 80};
        let offset = 0;

        for (let key in grid) {
            if (window.innerWidth < grid[key]) {
                offset = offsets[key];
                break;
            }
        }
        return Math.max(offset, overlayOffset);
    }

    let offset = getOffset();
    $(window).resize(function () {
        offset = getOffset();
    });

    const elements = [$('.navbar'),$('.navbar-info')];

    $(window).scroll(function () {
        let scrollPos = $(document).scrollTop();
        if (scrollPos > offset) {
            elements.forEach((element) => {
                element.addClass(['shrink']);
            });
        } else {
            //shrink already set?
            if (!$('#navBar').hasClass('show')) {
                elements.forEach((element) => {
                    if(element.hasClass('shrink')) {
                        element.removeClass('shrink');
                    }
                });
            }
        }
    });

    let scrollPos = $(document).scrollTop();
    if (scrollPos > offset) {
        elements.forEach((element) => {
            element.addClass(['shrink']);
        });
    }
    /*
    $(".navbar-collapse").on('show.bs.collapse', function(e) {
        let scrollPos = $(document).scrollTop();
        if (scrollPos <= offset) {
            elements.forEach((element) => {
                element.addClass(['shrink']);
            });
        }
    }).on('hide.bs.collapse', function(e) {
        let scrollPos = $(document).scrollTop();
        if (scrollPos <= offset) {
            elements.forEach((element) => {
                if(element.hasClass('shrink')) {
                    element.removeClass('shrink');
                }
            });
        }
    });
    */

}